import Modifier from 'ember-modifier';

import { string } from 'rise-ui/utils/string.js';

/**
 * Adds specified element attribute with given value
 * @param {string} attrName Name of attribute to add to element
 * @param {boolean} isAttrPresent Attribute only added if isAttrPresent is true
 * @param {string} [attrValue] Value for attribute
 */
export default class AttrModifier extends Modifier {
  _attrName;

  modify(element, [attrName, isAttrPresent, attrValue]) {
    if (this._attrName !== attrName) {
      if (this._attrName) {
        element.removeAttribute(this._attrName);
      }
      this._attrName = attrName;
    }
    if (!attrName) {
      return;
    }
    if (isAttrPresent) {
      element.setAttribute(String(attrName), string(attrValue));
    } else {
      element.removeAttribute(String(attrName));
    }
  }
}
